export default "__VITE_ASSET__DNpov1iS__"